import React, { Component } from "react"
import MetaTags from "react-meta-tags"
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  NavItem,
  NavLink,
  Progress,
  Row,
  TabContent,
  TabPane,
  InputGroup,
  Alert,
  Button,
  Modal
} from "reactstrap"

import classnames from "classnames"

import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import { AvForm, AvField, AvGroup } from "availity-reactstrap-validation"

import PropsTypes from "prop-types"
import { connect } from "react-redux"
import { postBirthDetailsInput, getPlacesAPIToken } from "store/actions"
import { inRange, isEmpty, isEqual } from "lodash"
import AsyncSelect from "react-select/async"
import { getPlaces } from "../../helpers/backend_helper"
import PageLoader from 'pages/Common/PageLoader'
import { countries } from "../../common/data/country"
import { GET_PLACES_API_TOKEN, POST_BIRTH_DETAILS_INPUT } from "store/projects/actionTypes"
import { RESULT_OK } from "store/baseActionTypes"
import { getInvoice, makePayment, togglePaymentModal } from "store/payments/actions"
import { GET_INVOICE, MAKE_PAYMENT, TOGGLE_PAYMENT_MODEL } from "store/payments/actionTypes"

class BirthchartInput extends Component {
  constructor(props) {
    super(props)

    this.state = {
      activeTab: 2,
      progressValue: 33.5,  //33.5, 67
      actionResultChanged: false,
      actionResult: {},
      actionResultChangedPayment: false,
      actionResultPayment: {},
      selectedPlace: [],
      passPlaceErrorField: '',
      passPlaceErrorElement: false,
      dateOfBirth: '',
      date: new Date(),
      time: '00:00 AM',
      loading: false,
      loadingPayment: false,
      country: 'IN',
      placesToken: '',
      invoiceDetails: {
        currency: 'INR',
        amount: 1000.00
      },
      status: 'success',
      message: 'Invoice generation failed, please contact kattam support.',

      modal_fullscreen: false,
      count: 1,
      birthDetail: {}
    }
    this.handleValidSubmit = this.handleValidSubmit.bind(this)
    this.handleGenerateBirthChartReport = this.handleGenerateBirthChartReport.bind(this)

  }

  // handleValidSubmit
  handleValidSubmit(event, values) {
    event.preventDefault();
    const { userBirthDetailInput } = this.props
    let birthDetail = values;
    birthDetail.tabValue = this.state.activeTab
    birthDetail.meridies = "Am"
    if (this.state.time === "00:00 AM") {
      birthDetail.timeOfBirth = "00:00:00 AM";
    }
    else {
      birthDetail.timeOfBirth = new Date(this.state.time).toTimeString();
    }
    birthDetail.dateOfBirth = new Date(this.state.date).toDateString();
    if (this.state.selectedPlace.length === 0) {
      this.setState({
        passPlaceErrorField: 'is-invalid',
        passPlaceErrorElement: true
      })
      return
    } else {
      birthDetail.placeId = this.state.selectedPlace.value
      birthDetail.placesToken = this.state.placesToken
      birthDetail.timeZone = 'UTC+05:30'

      this.setState({
        passPlaceErrorField: '',
        passPlaceErrorElement: false
      })
    }
    userBirthDetailInput(birthDetail)
  }

  handleGenerateBirthChartReport(event) {
    event.preventDefault();
    let birthChartId = this.props.birthDetail.id
    if (birthChartId != null && birthChartId != undefined)
      this.props.history.push("/users-birthchart/" + birthChartId)
  }

  handleSelectPlace = selectedPlace => {
    this.setState({
      selectedPlace: selectedPlace || []
    })
  }

  loadSelectedPlace = async (placeInput, callback) => {
    console.log("inisde loadSelectedPlace:::::::::::::::::::;")
    //const response = await fetch(`http://localhost:8181/api/getPlaces/${inputText}`);
    if (placeInput.length < 4)
      return;
    const response = await getPlaces(this.state.country, placeInput, this.state.placesToken)
    console.log(response)
    const json = await response
    console.log(json)
    callback(json.map(o => ({
      label: o.description,
      value: o.place_id + '|' + o.description,
      state: '',
      country: '',
      latitude: '',
      longitude: '',
      timeZone: ''
    })))
  }

  componentDidUpdate(prevProps, prevState) {
    console.log("BirthchartInput->componentDidUpdate->called")
    const { birthDetail, actionResult, loading,
      placesToken, getInvoice } = this.props

    if (!isEqual(prevProps.loading, loading)) {
      this.setState({ loading: loading })
    }

    if (!isEmpty(actionResult) && !isEqual(prevProps.actionResult, actionResult)) {
      console.log("componentDidUpdate->actionResult, ", actionResult)
      if (!isEmpty(birthDetail) && actionResult.action === POST_BIRTH_DETAILS_INPUT && actionResult.result === RESULT_OK) {
        this.setState({ birthDetail })
        console.log("birthDetail: ", birthDetail)
        this.props.history.push({ pathname: "/payments/invoice", state: { birthDetail } })
      }
      this.setState({ actionResult, actionResultChanged: true })
    }

    if (!isEmpty(placesToken) && !isEqual(prevProps.placesToken, placesToken)) {
      this.setState({ placesToken })
    }
  }

  componentDidMount() {
    const { placesAPIToken } = this.props
    placesAPIToken();
  }

  renderLoader = () => {
    console.log("loading :::", this.state.loading)
    if (this.state.loading === true)
      return <PageLoader loaderMsg="Generating report... please wait..." />
    return null
  }

  render() {
    const { birthDetail } = this.state
    return (
      <React.Fragment>
        <div className="page-content">
          {this.renderLoader()}
          <MetaTags>
            <title>
              Generate Birth Chart | Kattam - Birth Chart
            </title>
          </MetaTags>
          <Container fluid={true}>
            <Breadcrumbs title="" breadcrumbItem="Generate AI Report" />
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody>

                    <AvForm className="form-horizontal"
                      onValidSubmit={this.handleValidSubmit}
                    >
                      <Alert color="info" className="mb-4" role="alert">
                        <h5 className="font-size-16 me-3">Birth details</h5>
                      </Alert>
                      <Row>
                        <Col lg="6">
                          <AvGroup className="mb-3">
                            <Label>
                              Name <span style={{ color: 'red' }}>*</span>
                                    </Label>
                            <AvField
                              name="name"
                              placeholder="Name"
                              type="text"
                              errorMessage="Please enter a name"
                              className="form-control"
                              validate={{ required: { value: true } }}
                            />
                          </AvGroup>
                        </Col>
                        <Col lg="6">
                          <AvGroup className="mb-3 select2-container">
                          <Label>
                          Gender <span style={{ color: 'red' }}>*</span>
                                    </Label>
                            <AvField type="select"
                              name="gender"
                              // helpMessage="Idk, this is an example. Deal with it!"
                              required
                              errorMessage="Please select a gender"
                            >
                              <option disabled value="">Select gender</option>
                              <option>Male</option>
                              <option>Female</option>
                              <option>Others</option>
                            </AvField>
                          </AvGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="6">
                          <div className="form-group mb-4">
                          <Label>
                             Birth Date <span style={{ color: 'red' }}>*</span>
                          </Label>
                            <div className="input-group">
                              <Flatpickr
                                className="form-control d-block"
                                placeholder="dd M,yyyy"
                                options={{
                                  altInput: true,
                                  altFormat: "F j, Y",
                                  dateFormat: "Y-m-d",
                                  defaultDate: "today"
                                }}
                                onChange={date => {
                                  this.setState({ date });
                                }}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col lg="6">
                          <FormGroup className="mb-3">
                            <Label>Birth Time <span style={{ color: 'red' }}>*</span></Label>

                            <InputGroup>
                              <Flatpickr
                                className="form-control d-block"
                                placeholder="HH:MM AM"
                                options={{
                                  enableTime: true,
                                  noCalendar: true,
                                  dateFormat: "H:i",
                                  defaultDate: "00:00 AM",
                                  time_24hr: false,
                                  minuteIncrement: 1,
                                }}
                                onChange={time => {
                                  this.setState({ time });
                                }}
                              />
                              <div className="input-group-append">
                                <span className="input-group-text">
                                  <i className="mdi mdi-clock-outline" />
                                </span>
                              </div>
                            </InputGroup>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col className="col-md-6">
                          <div className="mb-3">
                          <Label>
                            Birth country <span style={{ color: 'red' }}>*</span>
                          </Label>
                            <AvField type="select" name="country"  onChange={(event) => {
                              let country = JSON.parse(event.target.value);
                              this.setState({
                                country: country.code,
                              })
                            }}
                            >
                              <option value="-1">Select Country</option>
                              {countries.map((country, index) => (
                                <option value={JSON.stringify(country)} key={index}>{country.name}</option>
                              ))}
                            </AvField>
                          </div>
                        </Col>
                        <Col lg="6">
                          <AvGroup className="mb-3">
                            <Label htmlFor="basicpill-place-input2">
                              Place of birth <span style={{ color: 'red' }}>*</span>
                                    </Label>
                            <AsyncSelect
                              value={this.state.selectedPlace}
                              onChange={this.handleSelectPlace}
                              placeholder={'Select place of birth'}
                              loadOptions={this.loadSelectedPlace}
                              classNamePrefix="select2-selection"
                              // className={this.state.passPlaceErrorField}
                              className="my-is-invalid"
                            />
                            {this.state.passPlaceErrorElement &&
                              <div className="my-invalid-feedback">Please select a place of birth</div>
                            }
                          </AvGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="6">
                          <AvGroup className="mb-3 select2-container">
                          <Label>
                          Birth type <span style={{ color: 'red' }}>*</span>
                                    </Label>
                            <AvField type="select"
                              name="birthType"
                              // helpMessage="Idk, this is an example. Deal with it!"
                              required
                              errorMessage="Please select a birth type"
                            >
                              <option disabled value="">Select birth type</option>
                              <option>Natural </option>
                              <option>Caesarean  </option>
                              <option>Vacuum Extraction</option>
                              <option>Forceps Delivery</option>
                            </AvField>
                          </AvGroup>
                        </Col>
                        <Col lg="6">
                          <AvGroup className="mb-3 select2-container">
                            <AvField type="select"
                              name="bloodGroup"
                              label="Blood Group"
                              // helpMessage="Idk, this is an example. Deal with it!"
                            >
                              <option disabled value="">Select blood group</option>
                              <option>A+</option>
                              <option>A-</option>
                              <option>B+</option>
                              <option>B-</option>
                              <option>AB+</option>
                              <option>AB-</option>
                              <option>O+</option>
                              <option>O-</option>
                            </AvField>
                          </AvGroup>
                        </Col>
                      </Row>
                      <Row>
                      <Col lg="6">
                          <AvGroup className="mb-3 select2-container">
                          <Label>
                              IQ Level
                          </Label>
                          <AvField
                              name="iqLevel"
                              placeholder="IQ Level"
                              type="text"
                              errorMessage="Please enter IQ Level"
                              className="form-control"
                              helpMessage=""
                              maxLength="3"
                              validate={{
                                pattern: { value: '^[0-9]{2,3}$', errorMessage: 'Please enter a valid 2 or 3 digit IQ Level' }
                              }}
                            />
                          </AvGroup>
                        </Col>
                        <Col lg="6">
                          <AvGroup className="mb-3">
                            <Label>
                            Referred by <span style={{ color: 'red' }}>*</span>
                                    </Label>
                            <AvField
                              name="refferedBy"
                              placeholder="Reffered by"
                              type="text"
                              errorMessage="Please enter "
                              className="form-control"
                              required
                              helpMessage="Reffered by self / Doctor name"
                            />
                          </AvGroup>
                        </Col>
                      </Row>
                      <div className="text-end mt-4">
                        <button
                          className="btn btn-primary btn-block waves-effect waves-light"
                          type="submit"

                        >
                          Submit
                         </button>
                      </div>
                    </AvForm>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div >
      </React.Fragment >
    )
  }
}

BirthchartInput.propsTypes = {
  userBirthDetailInput: PropsTypes.func,
  placesAPIToken: PropsTypes.func,
  togglePaymentModal: PropsTypes.func
}

const mapStateToProps = ({ projects }) => ({
  birthDetail: projects.userBirthDetailsInput,
  actionResult: projects.actionResult,
  loading: projects.loading,
  placesToken: projects.placesToken
})

const mapDispatchToProps = dispatch => ({
  userBirthDetailInput: (birthDetail) => dispatch(postBirthDetailsInput(birthDetail)),
  placesAPIToken: () => dispatch(getPlacesAPIToken())
})

export default connect(mapStateToProps, mapDispatchToProps)(BirthchartInput)
